import React from 'react';
import PropTypes from 'prop-types';

const GOOGLE_DEFAULT_COLOR_1 = '#4285F4';
const GOOGLE_DEFAULT_COLOR_2 = '#34A853';
const GOOGLE_DEFAULT_COLOR_3 = '#FBBC05';
const GOOGLE_DEFAULT_COLOR_4 = '#EA4335';

export default function Google({ logoColor, logoWidth, logoHeight }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={logoWidth} height={logoHeight} viewBox="0 0 25 24" fill="none">
            <title>Calendar Attachment Google</title>
            <path
                d="M24.2602 12.2727C24.2602 11.4218 24.1839 10.6036 24.0421 9.81818H12.7402V14.4655H19.1984C18.9148 15.96 18.0639 17.2255 16.7875 18.0764V21.0982H20.6821C22.9512 19.0036 24.2602 15.9273 24.2602 12.2727Z"
                fill={logoColor || GOOGLE_DEFAULT_COLOR_1}
            />
            <path
                d="M12.7401 24C15.9801 24 18.6965 22.9309 20.6819 21.0982L16.7874 18.0764C15.7183 18.7964 14.3546 19.2327 12.7401 19.2327C9.62008 19.2327 6.96917 17.1273 6.02008 14.2909H2.02734V17.3891C4.00189 21.3054 8.04917 24 12.7401 24Z"
                fill={logoColor || GOOGLE_DEFAULT_COLOR_2}
            />
            <path
                d="M6.02024 14.28C5.78024 13.56 5.63842 12.7963 5.63842 12C5.63842 11.2036 5.78024 10.44 6.02024 9.71995V6.62177H2.02751C1.20933 8.23631 0.740234 10.0581 0.740234 12C0.740234 13.9418 1.20933 15.7636 2.02751 17.3781L5.1366 14.9563L6.02024 14.28Z"
                fill={logoColor || GOOGLE_DEFAULT_COLOR_3}
            />
            <path
                d="M12.7401 4.77819C14.5074 4.77819 16.0783 5.3891 17.3328 6.56728L20.7692 3.13091C18.6855 1.18909 15.9801 0 12.7401 0C8.04917 0 4.00189 2.69455 2.02734 6.62183L6.02008 9.72001C6.96917 6.88364 9.62008 4.77819 12.7401 4.77819Z"
                fill={logoColor || GOOGLE_DEFAULT_COLOR_4}
            />
        </svg>
    );
}

Google.defaultProps = {
    logoColor: null,
    logoWidth: 25,
    logoHeight: 24,
};
Google.propTypes = {
    logoColor: PropTypes.string,
    logoWidth: PropTypes.number,
    logoHeight: PropTypes.number,
};
